import Close from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Skeleton from "@mui/material/Skeleton";
import { L } from 'harmony-language';
import React from 'react';
import { DeviceLocation, Load } from '../../types';
import { CircularLoading } from '../shared/circular-loading';
import { LiveMapDriverDetails } from './live-map-driver-details';
import { LiveMapStopStatus } from './live-map-stop-status';
import { LiveMapStopsChart, LiveMapStopsChartLegend } from './live-map-stops-chart';
import { getCurrentStop } from './utils/get-current-stop';
import { getTimeToNextStop } from './utils/time-to-next-stop';
import { useRouteData } from './utils/use-route-data';

export const LiveMapLoadDetails: React.FC<{ deviceLocation: DeviceLocation, load: Load, isLoading: boolean, onClose: () => void }> = (props) => {
    const { deviceLocation, load, isLoading, onClose } = props;

    const currentStop = getCurrentStop(load?.stops);

    // useRouteData - was having tons of here map calls because of the calls happening inside an useEffect
    // was working, until I needed to make loadsInTransit refetch on deviceLocation change (#2861), that change made here map calls go up to 3 per change instead of just 1
    // trying to just change useEffect dependency array to only include deviceLocation, will revist if this breaks something else unintentionally
    const routeInfo = useRouteData(deviceLocation, load);
    
    if (isLoading) return <CircularLoading />;
    return (
        <div className='live-map-order-info'>
            <Button className='live-map-close-sidebar-button' onClick={onClose}><Close /></Button>
            {load ? <>
                <LiveMapDriverDetails load={load} deviceLocation={deviceLocation} />

                <hr style={{ width: '100%' }} />

                <LiveMapStopStatus stop={currentStop} />
                {routeInfo ? <span className='remaining-time'>{L.expectedToArrive(getTimeToNextStop(routeInfo) || '')}</span> : <Skeleton />}
                <LiveMapStopsChart stops={load?.stops} route={routeInfo} />
                <LiveMapStopsChartLegend />
            </>
                :
                <div>{L.noLoad()}</div>}
        </div>
    );
};
